import { SelectOption } from '../../../../services/select/interfaces/SelectOption';
import { TermsChangeOption } from '../../../../enums/TermsChangeOption';

export const termsChangeOptions: SelectOption[] = [
  { title: 'Raised Range', value: TermsChangeOption.RaisedRange },
  { title: 'Lowered Range', value: TermsChangeOption.LowerRange },
  { title: 'No Change', value: TermsChangeOption.NoChange },
  { title: 'All', value: TermsChangeOption.All },
];
